import React from 'react';
import { motion } from 'framer-motion';
import { Sun, TrendingUp, Music, Wallet } from 'lucide-react';
const reasons = [{
  icon: Wallet,
  title: 'No State Income Tax',
  description: 'Enjoy significant financial benefits with zero state income tax, making it an ideal haven for wealth preservation.'
}, {
  icon: Music,
  title: 'World-Class Entertainment',
  description: 'Unrivaled dining, shows, and nightlife right at your doorstep, offering a lifestyle of endless excitement.'
}, {
  icon: Sun,
  title: 'Year-Round Sunshine',
  description: 'Over 300 days of sunshine annually, perfect for enjoying outdoor living, golf, and spectacular desert sunsets.'
}, {
  icon: TrendingUp,
  title: 'Strong Appreciation',
  description: 'A robust and growing real estate market providing excellent opportunities for long-term investment and equity growth.'
}];
export function WhyLasVegas() {
  return <section id="why-vegas" className="py-24 bg-white px-6 border-t border-warmGray-dark" data-id="element-544">
      <div className="max-w-7xl mx-auto" data-id="element-545">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-546">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-547">
            <span className="text-gold uppercase tracking-[0.2em] text-sm font-medium mb-4 block" data-id="element-548">
              The Advantage
            </span>
            <h2 className="text-4xl md:text-5xl font-serif text-charcoal mb-8" data-id="element-549">
              Why Relocate to <br data-id="element-550" />
              <span className="italic" data-id="element-551">Las Vegas?</span>
            </h2>
            <p className="text-lg text-charcoal-light font-light mb-10 leading-relaxed" data-id="element-552">
              Beyond the glittering lights of the Strip lies a sophisticated
              metropolis offering an unparalleled quality of life. With the
              addition of the MSG Sphere, Formula 1 Grand Prix, championship
              sports teams like the Raiders and Golden Knights, and a booming
              tech scene, Las Vegas has evolved into a premier global
              destination for luxury living and entertainment.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-8" data-id="element-553">
              {reasons.map((reason, index) => <div key={index} className="flex flex-col" data-id="element-554">
                  <div className="w-12 h-12 rounded-full border border-gold flex items-center justify-center mb-4 text-gold" data-id="element-555">
                    <reason.icon className="w-5 h-5" data-id="element-556" />
                  </div>
                  <h4 className="text-lg font-serif text-charcoal mb-2" data-id="element-557">
                    {reason.title}
                  </h4>
                  <p className="text-sm text-charcoal-light font-light leading-relaxed" data-id="element-558">
                    {reason.description}
                  </p>
                </div>)}
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="relative h-[600px]" data-id="element-559">
            <img src="https://images.unsplash.com/photo-1581351123004-757df051cb8e?q=80&w=2786&auto=format&fit=crop" alt="Las Vegas Skyline" className="w-full h-full object-cover" data-id="element-560" />
            <div className="absolute inset-0 border border-gold/30 m-4 pointer-events-none" data-id="element-561"></div>
          </motion.div>
        </div>
      </div>
    </section>;
}